<template>
  <nv-page header="IOS User Agent Discovery" data-cy="ios-ua-discovery">
    <template #toolbar>
      <v-spacer />
      <nv-btn
        v-if="items.length && $auth.hasPermissions('ant.discovery')"
        type="lock"
        data-cy="lock-btn"
        @click="reserve()"
      />
      <nv-table-search v-model="search" sync class="ml-4" data-cy="search" />
    </template>

    <template #filters>
      <nv-table-filters
        ref="applied-filters"
        v-model="formattedFilters"
        :no-clear="isDefaultFilters"
        @clear="$refs['filter-sheet'].clearFilters()"
      >
        <filter-sheet ref="filter-sheet" show-domain @changed="setTableFilters" />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td class="text-break">{{ item.user_agent }}</td>
          <td>{{ item.domain }}</td>
          <td class="text-break">{{ item.app_name }}</td>
          <td>{{ item.countries.join(', ') | uppercase }}</td>
          <td>{{ item.hits | number }}</td>
          <td>{{ item.last_seen_on | date }}</td>
        </tr>
      </template>
    </v-data-table>
  </nv-page>
</template>

<script>
import FilterSheet from '@/components/cls/FilterSheet';
import DiscoveryList from '@/components/cls/DiscoveryList';

const headers = [
  { text: 'User Agent', sortable: false, value: 'user_agent' },
  { text: 'Domain', sortable: false, value: 'domain' },
  { text: 'App Name', sortable: false, value: 'app_name' },
  { text: 'Countries', sortable: false, value: 'countries' },
  { text: 'Audience', sortable: false, value: 'rank' },
  { text: 'Last Seen', sortable: false, value: 'last_seen_on' },
];

export default {
  components: { FilterSheet },
  extends: DiscoveryList('ios/ua'),
  data: () => ({
    headers,
  }),
};
</script>
